import { BuilderStatus } from "../utils/Entities";
import { AlertTriangle, CheckCircle2, RefreshCcw } from "lucide-react";
import { ReactNode } from "react";

interface NavBarTabNameAndStatus {
  name: string;
  icon: ReactNode;
  state: BuilderStatus;
}

const NavBarTabNameAndStatus = ({ name, icon, state }: NavBarTabNameAndStatus) => {
  const pending = state === BuilderStatus.PENDING;
  const completed = state === BuilderStatus.COMPLETED;
  const failed = state === BuilderStatus.FAILED;

  return (
    <div className="flex flex-row items-center justify-between w-full">
      <div className="items-center flex flex-row gap-2">
        {icon}
        {name}
      </div>
      {failed && <AlertTriangle className="text-yellow-60" size={16} />}
      {pending && <RefreshCcw className="rotating-counter text-blue-60" size={16} />}
      {completed && <CheckCircle2 className="text-green-60" size={16} />}
    </div>
  );
};

export default NavBarTabNameAndStatus;
